import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';
import { requiredWhenPresent } from '../../shared/propTypes';
import { BookToTaxDifferencePropType } from './propTypes';


const DeleteBookToTaxDifferenceModal = ({
  rowIndex,
  entityToRemove,
  removeEntity,
  hideModal,
  isVisible,
  isRemovingInProgress,
  clearRangeSelection,
}) => {
  const removeBookToTaxDifference = useCallback(() => {
    removeEntity(entityToRemove, { rowIndex, clearRangeSelection });
  }, [removeEntity, entityToRemove, rowIndex, clearRangeSelection]);

  return (
    <Modal
      className="delete-book-to-tax-differences-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Book to Tax Difference"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeBookToTaxDifference}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete: <br/><br/>
              Exception Account: {entityToRemove.exceptionAccount}<br/>
              Exception Basis: {entityToRemove.exceptionBasis}<br/>
              Country Tax Types: {entityToRemove.countryTaxTypes.join(',')}<br/>
            </div>
          )
          : null
      }
    </Modal>
  );
};

DeleteBookToTaxDifferenceModal.propTypes = {
  entityToRemove: BookToTaxDifferencePropType,
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  isRemovingInProgress: PropTypes.bool,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  clearRangeSelection: PropTypes.func,
};

export default DeleteBookToTaxDifferenceModal;

